const cart_toggle = document.getElementById('cartToggle')
const cart_close = document.querySelector('.new-cart_close-button')
const new_cart_overlay = document.querySelector('.new-cart_overlay')
const new_cart_shell = document.querySelector('.new-cart_shell')

const newCartDisplayNone = () => {
  new_cart_overlay.style.display = "none"
}

cart_toggle.addEventListener('click', function(e) {
  e.preventDefault()
  
  new_cart_overlay.style.opacity = "1"
  new_cart_overlay.style.display = "block"
  new_cart_shell.style.transform = "translateX(0px)"
})

cart_close.addEventListener('click', function(e) {
  new_cart_overlay.style.opacity = "0"
  new_cart_shell.style.transform = "translateX(100%)"
  
  setTimeout(newCartDisplayNone, 900) // Slightly faster than the transition, helps it feel "snappy"
})